const defaultLang = ["zh-cn", "cn", "en", "vn", "th"]

export default defaultLang
